const toHue = (value) => {
  let hash = 0;
  for (let i = 0; i < value.length; i += 1) {
    hash = (hash * 31 + value.charCodeAt(i)) % 360;
  }
  return hash;
};

const hexToRgb = (hex) => {
  const clean = hex.replace('#', '');
  const r = parseInt(clean.slice(0, 2), 16);
  const g = parseInt(clean.slice(2, 4), 16);
  const b = parseInt(clean.slice(4, 6), 16);
  return { r, g, b };
};

const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

const mix = (a, b, weight) => Math.round(a * (1 - weight) + b * weight);

const lighten = (hex, amount) => {
  const { r, g, b } = hexToRgb(hex);
  return `rgb(${mix(r, 255, amount)}, ${mix(g, 255, amount)}, ${mix(b, 255, amount)})`;
};

const darken = (hex, amount) => {
  const { r, g, b } = hexToRgb(hex);
  return `rgb(${mix(r, 0, amount)}, ${mix(g, 0, amount)}, ${mix(b, 0, amount)})`;
};

const normalizeHex = (hex) => {
  if (!hex) return null;
  const value = hex.trim();
  if (!value) return null;
  const withHash = value.startsWith('#') ? value : `#${value}`;
  if (withHash.length !== 7) return null;
  return withHash.toUpperCase();
};

export const getCommitteeColor = (name = '', hex = null) => {
  const normalized = normalizeHex(hex);
  if (normalized) {
    return {
      accent: normalized,
      soft: lighten(normalized, 0.9),
      gradient: `linear-gradient(135deg, ${normalized}, ${darken(normalized, 0.2)})`,
    };
  }

  const hue = toHue(name || 'committee');
  return {
    accent: `hsl(${hue} 70% 45%)`,
    soft: `hsl(${hue} 80% 96%)`,
    gradient: `linear-gradient(135deg, hsl(${hue} 80% 50%), hsl(${(hue + 25) % 360} 85% 55%))`,
  };
};
